import React, { Suspense } from 'react';
import { connect } from 'react-redux';
import store from '../../../helpers/store';
import Logger from '../../../../common/logger';
import MaximizedFrame from '../../frames/maximized';
import MinimizedFrame from '../../frames/minimized';
import ChatMinimizedFrame from './chatminimized';
// import Registration from './registration';
import ChatApp from './chatapp';
import { markAllEventsAsRead } from './actions';
import { MESSAGE_TYPE } from './actions';
// import GenesysDriver from '../../../genesys/apiv2';
import { API } from '../../../api';
import { VIEW_MODES } from '../types';
import IPC from '../../../helpers/ipc';
import { WIDGET_ACTIONS } from '../../layers/widget/types';
import { COOKIES } from '../../layers/widget/types';
import ChatAPI from './ChatAPI';
import PreloaderWidget from '../preloader/widget';
import Tracker from '../../../genesys/tracker';
import './style.scss';

export const TITLE = 'Orange Czat';

const Registration = React.lazy(() =>
    import(/* webpackChunkName: "opl-wc-views.chat.registration" */ './registration/index')
);

class Chat extends React.Component {
    constructor(props) {
        super(props);

        // this.genesys = new GenesysDriver(store);
        this.API = new API(store);
        ChatAPI.set(this.API);
        this.lastUnreadMessages = [];

        // this.registrationHandler = this.registrationHandler.bind(this);
    }

    componentDidMount() {
        this.lastUnreadMessages = this.props.unreadMessages;
        IPC.sendEvent(COOKIES.START_CHAT);
        IPC.sendEvent(COOKIES.CHECK_USABILA);
    }

    componentDidUpdate() {
        const unreadMessages = this.props.unreadMessages;
        if (unreadMessages.length > 0 && this.lastUnreadMessages.length != unreadMessages.length) {
            const message = unreadMessages[unreadMessages.length - 1];
            IPC.sendEvent(WIDGET_ACTIONS.CHAT_MESSAGERECEIVED, message); // send message to parent which will handle OPLWidget.OnMessageReceived()
        }
        if (
            unreadMessages.length > 0 &&
            this.lastUnreadMessages.length != unreadMessages.length &&
            (this.props.layerConfig.currentMode === VIEW_MODES.MINIMIZED || document.hidden)
        ) {
            Logger.log('New message: unread count=' + unreadMessages.length);

            if (this.props.viewConfig.chatOptions.audioNotification || false) {
                const audio = this.audioElement;
                if (audio) {
                    audio.play();
                }
            }
            if (this.props.viewConfig.chatOptions.browserNotification || false) {
                const notifyUser = () => {
                    const message = unreadMessages[unreadMessages.length - 1];
                    const body =
                        message.username !== undefined && message.username !== null
                            ? message.username + ': ' + message.message
                            : message.message;
                    var notification = new Notification(TITLE, { body });
                    notification.onclick = () => window.focus();
                };

                if ('Notification' in window) {
                    if (Notification.permission === 'granted') {
                        // If it's okay let's create a notification
                        notifyUser();
                    } else if (Notification.permission !== 'denied') {
                        // Otherwise, we need to ask the user for permission
                        Notification.requestPermission(function (permission) {
                            // If the user accepts, let's create a notification
                            if (permission === 'granted') {
                                notifyUser();
                            }
                        });
                    }
                }
            }
        }
        this.lastUnreadMessages = unreadMessages;
    }

    componentWillUnmount() {
        // this.genesys.closeChat();
        this.API.close();
        IPC.sendEvent(COOKIES.STOP_CHAT);
    }

    render() {
        const { chat, layerConfig } = this.props;

        const config = this.props.viewConfig.chatOptions;

        const events = {
            ...this.props.events,
            close: () => {
                Tracker.sendViewResult('chat', 'leadCHATClosed', 'CHAT');
                this.props.events.close('chat');
            },
            minimize: () => {
                this.props.dispatch(markAllEventsAsRead());
                this.props.events.minimize();
            }
        };

        switch (this.props.mode) {
            case VIEW_MODES.MINIMIZED:
                if (config.registration && !chat.registration.registered) {
                    return <MinimizedFrame icon="chat" title={TITLE} events={events} />;
                } else {
                    return (
                        <ChatMinimizedFrame
                            icon="chat"
                            // badgeCount={10}
                            title={TITLE}
                            events={events}
                            config={config}
                            userdata={config.chatUserData}
                            // genesys={this.genesys}
                            API={this.API}
                        >
                            {config.audioNotification && (
                                <audio
                                    ref={(el) => (this.audioElement = el)}
                                    src={config.fileNewMessage}
                                />
                            )}
                        </ChatMinimizedFrame>
                    );
                }
            case VIEW_MODES.MAXIMIZED:
                if (config.registration && !chat.registration.registered) {
                    return (
                        <MaximizedFrame
                            events={events}
                            title={TITLE}
                            delays={{
                                showAfter:
                                    layerConfig.isInitView && config
                                        ? parseInt(config.showAfter || 0)
                                        : 0,
                                hideAfter:
                                    layerConfig.isInitView && config
                                        ? parseInt(config.hideAfter || 0)
                                        : 0
                            }}
                        >
                            <Suspense fallback={<PreloaderWidget icon="spinner" />}>
                                <Registration
                                    config={config}
                                    chatUserData={this.props.viewConfig.chatUserData}
                                />
                            </Suspense>
                        </MaximizedFrame>
                    );
                } else {
                    return (
                        <MaximizedFrame
                            title={TITLE}
                            events={events}
                            mainClassName=""
                            delays={{
                                showAfter:
                                    layerConfig.isInitView && config
                                        ? parseInt(config.showAfter || 0)
                                        : 0,
                                hideAfter:
                                    layerConfig.isInitView && config
                                        ? parseInt(config.hideAfter || 0)
                                        : 0
                            }}
                        >
                            <ChatApp
                                // genesys={this.genesys}
                                API={this.API}
                                config={config}
                                userdata={config.chatUserData}
                                closeAction={events.close}
                            />
                            {config.audioNotification && (
                                <audio
                                    ref={(el) => (this.audioElement = el)}
                                    src={config.fileNewMessage}
                                />
                            )}
                        </MaximizedFrame>
                    );
                }
            default:
                return null;
        }
    }
}

Chat.defaultProps = {
    unreadMessages: []
};

const getUnreadMessages = (messages) => {
    return messages.filter(
        (m) =>
            m.from !== 'client' &&
            (m.isRead === undefined || m.isRead === false) &&
            m.type !== MESSAGE_TYPE.CUSTOMMESSAGE
    );
};

const mapStateToProps = (state) => {
    return {
        chat: state.chat,
        unreadMessages: getUnreadMessages(state.chat.messages)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
        // close: () => dispatch(WidgetActions.onSwitchView({view: 'chatSave'}))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Chat);
